package com.appsyde.shared.modules.ticket.domain.model

data class TicketRespondState(
    val ticket: Ticket,
    val messages: List<TicketRespondMessage>,
    val draft: TicketDraft?,
    val lastInboundMessageId: String?
)

data class TicketRespondMessage(
    val messageId: String,
    val direction: Direction,
    val sentAtMs: Long,
    val summary: String?,
    val bodyPreview: String?,
    val authorEmail: String?,
    val hasAttachments: Boolean,
    val originalBody: String? = null,
    val attachments: List<MessageAttachment> = emptyList()
)

data class MessageAttachment(
    val id: String,
    val filename: String,
    val mimeType: String,
    val sizeBytes: Long? = null
)

data class TicketDraft(
    val status: String,
    val body: String?,
    val updatedAtMs: Long?
)
